var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.podcastitems),function(p){return _c('p',{key:p},[_vm._v(" "+_vm._s(p.title)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }